import { Button, TextField, Container, IconButton, Typography,Radio, RadioGroup, Box, Paper } from "@mui/material";
import DefaultUserIcon from "@mui/icons-material/Person";
import {  alpha } from "@mui/material/styles";
import { styled as muiStyled } from "@mui/material/styles";
import styled, { keyframes } from 'styled-components';


export const PRIMARY = "#1c3477";
export const ERROR = "#e53935";


export const NewChatButton = styled(Button)`
  background-color: ${PRIMARY} !important;
`

export const ControlPanel = muiStyled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(1),                   
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.background.default,  
  borderRadius: theme.shape.borderRadius,       
  border: `1px solid ${theme.palette.divider}`,  
  boxShadow: 'none',                           
}));
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
export const SidebarControls = muiStyled("div")(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
}));
export const StyledSearchInput = styled(TextField)(({ theme }) => ({
  width: '100%',
  height: 36,
  borderRadius: 20,
  backgroundColor: '#f7f8fa',
  '& .MuiOutlinedInput-root': {
    borderRadius: 20,
    '& fieldset': {
      borderColor: theme.palette.divider,
      borderWidth: 1,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.16)}`,
    },
  },
}));
// Layout
export const LoginWrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f1f6ff;
`;

export const LoginBox = styled('div')`
  background: #e4f6fd;
  padding: 40px 30px;
  border-radius: 25px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 360px;
`;

export const Logo = styled.img`
   width: 50px; 
   height: 50px;
   margin-bottom: 15px; 
   align-self: center;
`;

export const FieldWrapper = styled.div`
  width: 100%;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FieldLabel = styled.label`
  font-weight: 600;
  color: ${PRIMARY};
  margin-bottom: 5px;
  font-size: 14px;
  letter-spacing: 0.5px;
`;
export const StyledInputWrapper = styled.div`
  width: 100%;
  padding: 16px 0;
background-color: transparent; 
  position: sticky;
  bottom: 0;
  z-index: 100;
`;


export const StyledInput = styled.input`
  width: 100%;
  padding: 12px 18px;
  border-radius: 6px; 
  border: 1.5px solid #ffffff;
  font-size: 15px;
  font-weight: 500;
  color: ${PRIMARY};
  background-color: #ffffff;
  outline: none;
  transition: all 0.2s ease;

  &::placeholder {
    color: #aaa;
    font-weight: 400;
    opacity: 0.8;
  }

  &:hover {
    border-color: #b3b3b3;
  }

  &:focus {
    border-color: ${PRIMARY};
  }

  @media (max-width: 600px) {
    font-size: 14px;
    padding: 10px 14px;
  }
`;


export const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 10px !important;
  background-color: #1c3477 !important;  
  color: white !important;
  border-radius: 8px !important;
  font-weight: 600;
  text-transform: none;

  &:hover {
    background-color: #142654 !important;
  }

  @media (max-width: 600px) {
    font-size: 14px;
  }
`;



export const ErrorText = styled(Typography)`
  color: ${ERROR};
  margin-bottom: 10px;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
`;

export const SettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #091a4f; 
  color: white;
  padding: 0 20px;
`;

export const Heading = styled(Typography)`
  margin-bottom: 30px;
  font-weight: bold;
  font-size: 2rem;
`;

export const SettingsButton = styled(Button)`
  background-color: #97e2f8;
  color: #091a4f;
  border-radius: 20px;
  padding: 10px 20px;
  margin-top: 20px;
  font-weight: 600;
  text-transform: none;

  &:hover {
    background-color: #80c6e2;
  }
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  padding: 30px 20px;
  background: #ffffff;
  color: #091a4f;
  font-family: sans-serif;
  position: relative;
  
  @media (max-width: 600px) {
    padding: 20px 10px;
  }
`;

export const Title = styled.h2`
  color: #1c3477;
  margin-bottom: 8px;
`;

export const ConnectionForm = styled.div`
  margin-top: 20px;
  background: #f5f8ff;
  padding: 25px;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  max-width: 600px;
  width: 100%;
  
  h3 {
    margin: 20px 0 10px;
    color: #1c3477;
  }
  
  @media (max-width: 600px) {
    padding: 20px 15px;
  }
`;

export const SaveButton = styled(Button)`
  margin-top: 25px !important;
  background-color: #1c3477 !important;
  font-weight: bold;
  text-transform: none !important;
  border-radius: 20px !important;
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: 15px;
  right: 15px;
  color: #091a4f !important;
`;

export const FileInput = styled.input`
  margin: 15px 0;
  color: #091a4f;
  border: 1px dashed #ccc;
  padding: 12px;
  border-radius: 12px;
  width: 100%;
  background-color: #f1f6ff;
  cursor: pointer;
  font-family: inherit;
  
  &::file-selector-button {
    background: #1c3477;
    border: none;
    color: white;
    padding: 8px 14px;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
  }
  
  &:hover {
    border-color: #1c3477;
  }
`;

export const StyledTextField = styled(TextField)`
  background-color: #f1f6ff !important;
  border-radius: 20px !important;
  & label {
    color: #1c3477 !important;
  }
  & .MuiInputBase-input {
    color: #091a4f !important;
  }
`;

export const SidebarWrapper = styled.div`
  width: 300px;
  background-color: #edf4ff;
  padding: 20px;
  overflow-y: auto;
  border-right: 1px solid #cbd6e2;
`;

export const Header = styled.h2`
  color: ${PRIMARY};
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 700;
`;

export const NewChatButtonOld = styled.button`
  padding: 10px 18px;
  margin-bottom: 15px;
  border: none;
  border-radius: 30px;
  background-color: ${PRIMARY};
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #162b5e;
  }
`;

export const SearchInput = styled.input`
  padding: 10px 14px;
  width: 100%;
  margin-bottom: 20px;
  border: 1px solid #cbd6e2;
  border-radius: 25px;
  font-size: 14px;
  outline: none;
  transition: border 0.2s ease;

  &:focus {
    border-color: ${PRIMARY};
  }
`;

export const ChatItemContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background-color: #f9fbff;
  border-radius: 12px;
  margin-bottom: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`;

export const TitleText = styled.span`
  flex-grow: 1;
  margin-right: 8px;
  font-weight: 500;
  color: #1a1a1a;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChatItem = styled.div<{ selected: boolean }>`
  padding: 10px 14px;
  border-radius: 12px;
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? "#dceeff" : "transparent")};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #e7f2ff;
  }
`;

export const ChatContainer = styled.div`
  display: flex;
  height: 100vh;
  background-color: #ffffff;
  width: 100%;
  color: #091a4f;
  overflow: hidden; 
  font-family: sans-serif;
  
  position: relative; /* Allow positioning child elements */
`;
export const Sidebar = styled.div<{ collapsed: boolean }>`
  width: 280px; 
  position: fixed;
  display: flex;     
  flex-direction: column; 
  top: 0;
  left: 0;
  height: 100vh;
  background-color: #edf4ff;
  padding: 20px;
  overflow-x: hidden;
  border-right: 1px solid #cbd6e2;

transform: ${({ collapsed }) => (collapsed ? "translateX(-280px)" : "translateX(0)")};
  transition: transform 0.3s ease-in-out;
  z-index: 1100;
`;
export const UserAvatarContainer = styled.div`
  display: flex;               
  align-items: center;       
  margin-top: auto;           
  padding: 15px;               
`;


export const SidebarHandle = styled('div')<{ collapsed: boolean }>`
  position: fixed;
  top: 16px;
left: ${({ collapsed }) => (collapsed ? '8px' : 'calc(230px)')};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #1c3477;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  transition: all 0.3s ease;

  &:hover {
    background-color: #142654;
    transform: scale(1.05);
  }

  z-index: 1100;
`;


export const ChatList = styled.div`
  margin-top: 16px;
  flex-grow: 1;
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 100px;
  max-height: calc(100vh - 250px);

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c0cde4;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

export const ChatListItem = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 38px;
  width: 100%;
  padding: 10px 12px;
  border-radius: 12px;

  font-weight: ${(props) => (props.active ? "600" : "500")};
  color: ${(props) => (props.active ? "#1c3477" : "#1a1a1a")};
  background-color: ${(props) => (props.active ? "#dceeff" : "transparent")};
  box-shadow: ${(props) =>
    props.active ? "inset 4px 0 0 #1c3477" : "none"};

  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  cursor: pointer;

  &:hover {
    background-color: ${(props) =>
      props.active ? "#dceeff" : "#f0f6ff"};
  }
`;

export const TitleText1 = styled.span`
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
`;



 export const ChatTitle = styled.h2`
 color: #1c3477;
 margin-bottom: 15px; // Reduced margin?
 text-align: center; // Center title?
 font-size: 1.1rem; // Adjust size?
`;

export const AvatarImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: white;
  cursor: pointer;
`;

export const DefaultAvatarIcon = styled(DefaultUserIcon)`
  font-size: 40px !important;
  color: black;
  background: white;
  border-radius: 50%;
  cursor: pointer;
  padding: 4px;
`;

export const AvatarSettingsButton = styled(Button)`
  margin-top: 8px;
  font-size: 13px;
  padding: 4px 10px;
  background-color: #edf4ff !important;
  color: #091a4f !important;
  text-transform: none;
  border-radius: 20px;
  &:hover {
    background-color: #d4e7ff !important;
  }
`;


export const ChatMain = styled.main<{ isSidebarCollapsed: boolean }>`
  flex: 1;
  margin-left: ${({ isSidebarCollapsed }) =>
    isSidebarCollapsed ? "0" : "140px"};
  transition: margin-left 0.3s ease;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
`;






export const MessagesWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
`;


export const InputWrapper = styled.div`
  display: flex;
  padding: 10px;
  background-color: #edf4ff;
  flex-direction: row;
  align-items: center;
`;

export const SettingsPage = styled.div<{ isVisible: boolean }>`
  display: ${(props) => (props.isVisible ? "flex" : "none")};
  flex-direction: column;
  width: 50%;
  background-color: #ffffff;
  padding: 20px;
  color: #091a4f;
  overflow-y: auto;
  margin-left:350px;
`;

export const SettingsInput = styled(TextField)`
  background-color: #f1f6ff !important;
  border-radius: 25px !important;
  margin-bottom: 15px !important;
  & label {
    color: #1c3477 !important;
  }
  & .MuiInputBase-input {
    color: #091a4f !important;
  }
`;

export const PreferencesSection = styled.div`
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ccc;
`;

export const ConnectionPopup = styled.div<{ isVisible: boolean }>`
  display: ${(props) => (props.isVisible ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  
  transform: translate(-50%, -50%);
  width: 400px;
  background: #edf4ff;
  padding: 30px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  color: #091a4f;
`;
export const MessageContentWrapper = styled('div')<{ isUser: boolean }>`
  display: inline-block;
  background-color: ${({ isUser }) => (isUser ? '#d2e3ff' : '#ffffff')};
  color: #1c3477;
  padding: 12px 16px;
  border-radius: 20px;
  border-top-${({ isUser }) => (isUser ? 'right' : 'left')}-radius: 0;
  max-width: ${({ isUser }) => (isUser ? '65%' : '100%')};
  width: ${({ isUser }) => (isUser ? 'fit-content' : '100%')};
  white-space: pre-wrap;
  word-wrap: break-word;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
`;



export const MessageBubble = styled.div<{ isUser: boolean }>`
  max-width: 100%;
  margin-bottom: 16px;
  display: flex;
  justify-content: ${({ isUser }) => (isUser ? 'flex-end' : 'flex-start')};
  animation: ${fadeInUp} 0.3s ease-out;
`;


export const SendButton = styled(Button)`
  border-radius: 50%;
  min-width: 48px;
  height: 48px;
  background-color: #1c3477;
  color: #ffffff;
  box-shadow: 0px 2px 6px rgba(28, 52, 119, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.3s ease;
  &:hover {
    background-color: #142654;
    transform: scale(1.1);
    box-shadow: 0px 4px 12px rgba(20, 38, 84, 0.4);
  }
  &:active {
    transform: scale(0.95);
    box-shadow: 0px 1px 3px rgba(28, 52, 119, 0.2);
  }
`;


export const RadioGroupStyled = styled(RadioGroup)`
  margin-bottom: 20px;
  color: #091a4f;
`;

export const RadioStyled = styled(Radio)`
  color: #1c3477;
  &.Mui-checked {
    color: #1c3477;
  }
`;
export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  text-align: center;
  background: #f7f8fa;
`;

export const EmptyTitle = styled(Typography)`
  && {
    font-size: 1.5rem;
    font-weight: 600;
    color: ${PRIMARY};
    margin-bottom: 8px;
  }
`;

export const EmptySubtitle = styled(Typography)`
  && {
    font-size: 1rem;
    color: #5f6c82;
    margin-bottom: 24px;
  }
`;
